<template>
  <div class="d-flex justify-content-center ml-2">
    <input
      v-for="(digit, index) in digits"
      :key="index"
      ref="digit"
      class="form-control form-control-lg font-weight-bold at_input mt-4 mr-2"
      required
      type="text"
      pattern="\d*"
      maxlength="1"
      v-model="readingArray[index]"
      @keypress="updateReading($event, index)"
      @keydown.delete="reverseAutotab($event, index)"
      @paste="onPaste"
    />
  </div>
</template>

<script>
export default {
  name: 'readingInput',
  props: {
    digits: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      readingArray: []
    };
  },
  mounted() {
    this.readingArray = Array.from(new Array(this.digits)); // Creates a sparse array
  },
  methods: {
    updateReading($event, index) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which; // Make sure keycode has a value
      // Only if keycode represents a digit
      if (keyCode > 47 && keyCode < 58) {
        // If there is already a value in input then replace it.
        if (
          this.readingArray[index] !== undefined ||
          this.readingArray[index] !== $event.key
        ) {
          this.readingArray[index] = $event.key;
          this.$forceUpdate(); // Wait for DOM to update
        }

        // Fill all inputs before current input
        for (let i = 0; i < index; i++) {
          if (!this.readingArray[i]) {
            this.readingArray[i] = '0';
          }
        }
        this.$forceUpdate(); // Wait for DOM to update

        this.autotab($event, index); // Move to next input box
        this.updateReadingValue(); // Update the reading value without validation
      } else {
        // If keycode doesn't represent a digit then ignore it.
        return $event.preventDefault();
      }
    },

    autotab($event, index) {
      if (index + 1 < this.digits) {
        // If there is another input after current one move focus to it
        $event.target.nextElementSibling.focus();
      }
    },

    reverseAutotab($event, index) {
      $event.preventDefault();
      this.readingArray[index] = undefined;
      this.updateReadingValue();
      this.$forceUpdate(); // Wait for DOM to update
      // this.readingArray.splice(index, 1);
      if (index) {
        return $event.target.previousElementSibling.focus();
      }
    },

    onPaste(e) {
      let pastedData = e.clipboardData
        .getData('Text')
        .replace(/[^0-9]+/g, '')
        .trim()
        .padStart(this.digits, '0');

      window.setTimeout(() => {
        // Do something immediately after the paste event
        for (let index = 0; index < this.digits; index++) {
          this.readingArray[index] = pastedData[index];
        }
        this.$refs.digit[this.digits - 1].focus();
        this.$forceUpdate(); // Wait for DOM to update
        this.updateReadingValue();
      });
    },

    updateReadingValue() {
      if (!this.readingArray.includes(undefined)) {
        let reading = this.readingArray.join('');
        this.$emit('setReading', reading);
      } else {
        this.$emit('setReading', undefined);
      }
    },

    validateReading() {
      this.$emit('resetValidation');
      if (!this.readingArray.includes(undefined)) {
        let reading = this.readingArray.join('');
        this.$emit('setReading', reading);
      }
      /*
      let reading = undefined;
      if (!this.readingArray.includes(undefined)) {
        reading = this.readingArray.join("");
        +reading;
      }

      this.$emit('change', reading);
      */
    },

    clearInput() {
      this.readingArray = Array.from(new Array(this.digits));
      this.$forceUpdate(); // Wait for DOM to update
      this.$emit('setReading', undefined);
    }
  },

  watch: {
    digits() {
      this.readingArray = Array.from(new Array(this.digits));
    }
  }
};
</script>
